import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import PackageList from '../components/packages/PackageList';
import WalletModal from '../components/wallet/WalletModal';

const Packages = () => {
  const { account } = useWallet();
  const [refreshKey, setRefreshKey] = useState(0);
  const user = useUserData(refreshKey);
  const [open, setOpen] = useState(false);

  const activeCount = (user.packageStatuses || []).filter((p) => p?.isActive).length;
  const highest = user.core?.highestPackage || 0;

  return (
    <Layout dashboard>
      <div className="page-header">
        <div className="page-title">Tier Ladder</div>
        <div className="page-subtitle">
          Climb 7 tiers — each unlocks the next. {user.registered && (
            <span style={{ color: 'var(--bnb-yellow)' }}>
              {activeCount}/7 active · highest tier {highest || '—'}
            </span>
          )}
        </div>
      </div>

      {!account && (
        <div className="card" style={{ textAlign: 'center', marginBottom: 24 }}>
          <div className="card-title">Connect Wallet</div>
          <div className="card-sub" style={{ marginTop: 4 }}>Connect a wallet to interact with packages.</div>
          <button className="btn btn-primary" style={{ marginTop: 12 }} onClick={() => setOpen(true)}>Connect Wallet</button>
        </div>
      )}

      <PackageList user={user} onChanged={() => setRefreshKey((k) => k + 1)} />
      <WalletModal open={open} onClose={() => setOpen(false)} />
    </Layout>
  );
};

export default Packages;
